var submenu = {
	$this: $( '.js-submenu' ),
	$title: $( '.js-submenu h4' ),
	$nav: $( '.js-submenu .nav' )
};

function openItem( $this ) {
	$this.next('ul').slideDown('fast', function() {
		$this.parents('li').addClass('is-open');
	} );
}

function closeItem( $this ) {
	$this.next('ul').slideUp('fast', function() {
		$this.parents('li').removeClass('is-open');
	} );
}

submenu.init = function() {

	submenu.$this.find( '.icon' ).on( 'click', function( e ) {
		e.preventDefault();
		var $this = $(this);
		if ( $this.parent('li').hasClass('is-open')) {
			closeItem( $this );
		} else {
			openItem( $this );
		}
	} );

	if ( $( '.js-submenu .current-menu-item' ).length > 0 ) {
		openItem( $( '.js-submenu .current-menu-item' ).children( '.icon' ) );
		openItem( $( '.js-submenu .current-menu-item' ).parents( 'li.menu-item-has-children' ).children( '.icon' ) );
	}

	if ( Modernizr.mq( '(max-width: 1023px)' ) ) { // tablet & mobile:
		submenu.$title.on( 'click', function( e ) {
			e.preventDefault();
			const $this = $( this );
			if ( $this.hasClass( 'is-active' ) ) {
				submenu.$nav.css( 'max-height', 0 );
				$this.removeClass( 'is-active' );
			} else {
				const h = submenu.$this.find('ul').outerHeight( true );
				submenu.$nav.css( 'max-height', h );
				$this.addClass( 'is-active' );
			}
		} );
	}

}

export { submenu };
